import { Link } from "react-router-dom";
import { t } from "../constants/i18n";
import { STATUS_META } from "../constants/status";
import { useRemoteProducts } from "../hooks/useRemoteData";
import type { Lang } from "../constants/i18n";
import type { ProductStatus } from "../constants/products";
import "./Projects.css";

interface ProductsProps {
  lang: Lang;
}

const statusColor = (s: ProductStatus) => STATUS_META[s]?.color ?? "var(--text-dim)";

export default function Products({ lang }: ProductsProps) {
  const { data: PRODUCTS } = useRemoteProducts();
  return (
    <div className="products-page">
      <div className="products-hero">
        <div className="container">
          <h1 className="products-title">{t(lang, "products_title")}</h1>
          <p className="products-subtitle">{t(lang, "products_subtitle")}</p>
        </div>
      </div>
      <div className="products-body">
        <div className="container">
          {PRODUCTS.length === 0 ? (
            <p className="products-empty">{t(lang, "products_empty")}</p>
          ) : (
            <div className="products-grid">
              {PRODUCTS.map((p) => {
                const color = statusColor(p.status);
                const statusLabel =
                  (lang === "jp" ? STATUS_META[p.status]?.label_jp : STATUS_META[p.status]?.label_en) ??
                  p.status;
                return (
                  <Link key={p.id} to={`/products/${p.slug}`} className="product-card">
                    <div className="product-card-top">
                      <span className="product-name">{p.name}</span>
                      <span className="product-status" style={{ color, borderColor: color + "44" }}>
                        {statusLabel}
                      </span>
                    </div>
                    <p className="product-desc">{p.desc[lang] ?? p.desc.en}</p>
                    <div className="product-footer">
                      <div className="product-tags">
                        {p.tags.map((tag) => (
                          <span key={tag} className="product-tag">
                            {tag}
                          </span>
                        ))}
                      </div>
                      {p.isPrivate ? (
                        <span className="project-private">
                          <svg
                            width="9"
                            height="9"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <rect x="3" y="11" width="18" height="11" rx="2" />
                            <path d="M7 11V7a5 5 0 0110 0v4" />
                          </svg>
                          {t(lang, "card_private")}
                        </span>
                      ) : (
                        <span className="product-arrow">→</span>
                      )}
                    </div>
                    <span className="product-year">{p.year}</span>
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
